/**
 * "Phone held sideways": landscape, short AND not wide. The shell is built for tall screens (header 64px + bottom nav
 * 64px leave ~260px of a 390px-high phone), and width alone cannot tell a phone on its side from a tablet, so
 * this is decided by height (a landscape tablet is well above 500px tall) plus a width cap so an unusually short desktop window is not mistaken for a phone. In this mode the header shrinks to
 * LANDSCAPE_HEADER_HEIGHT, the bottom nav becomes a left rail of LANDSCAPE_RAIL_WIDTH and the sidebar is hidden,
 * whatever the width is (the larger phones are wider than the `md` breakpoint when sideways).
 */
export const LANDSCAPE_PHONE_QUERY = "(orientation: landscape) and (max-height: 500px) and (max-width: 1024px)"
export const LANDSCAPE_PHONE_MEDIA = `@media ${LANDSCAPE_PHONE_QUERY}`

export const LANDSCAPE_HEADER_HEIGHT = 48
export const LANDSCAPE_RAIL_WIDTH = 56

/**
 * `sx` fragment applying `styles` only for a phone held sideways. Doubled selector (`&&`) so it wins over the
 * `md`/`xs` responsive values of the same element regardless of the order MUI emits the media queries in -
 * without it a wide phone (>= 900px) would keep its desktop values.
 */
export function landscapePhone(styles: Record<string, unknown>): Record<string, unknown> {
  return { [LANDSCAPE_PHONE_MEDIA]: { "&&": styles } }
}
